// extracted by mini-css-extract-plugin
export default {"miniNavbar":"MiniNavbar_miniNavbar__qqi+V","gradientShift":"MiniNavbar_gradientShift__exbiw","left":"MiniNavbar_left__vwev7"};